export default {"src":"/trader-new/_next/static/media/TranscatioFooter.2848d216.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};